import {EventEmitter} from "@angular/core";

export interface Headers {
  name: string;
  value: string;
}

export interface ParsedResponseHeaders {
  [headerFieldName: string]: string
}

export interface FileUploaderOptions {
  allowedMimeType?: string[];
  allowedFileType?: string[];
  maxFileSize?: number;
  url: string;
  headers?: Headers[];
}

export class FileLikeObject {
  lastModifiedDate: any;
  size: any;
  type?: string;
  name?: string;
  rawFile: HTMLInputElement | File;

  constructor(file: File) {
    this.rawFile = file;
    this.size = file.size;
    this.type = file.type;
    this.name = file.name;
  }
}

export class FileItem {
  file: FileLikeObject;
  _file: File;
  method: string;
  url?: string;
  alias?: string;
  isReady = false;
  isUploading = false;
  index?: number;
  protected uploader?: FileUploader;
  public _xhr?: XMLHttpRequest;
  headers: any = [];

  constructor(uploader: FileUploader, file: File) {
    this.uploader = uploader;
    this.file = new FileLikeObject(file);
    this._file = file;
    this.method = 'POST';
    this.alias = 'file';
    this.url = uploader.options.url;

  }

  _prepareToUploading(): void {
    this.index = this.index || ++this.uploader._nextIndex;
    this.isReady = true;
  }
}

export class FileUploader {
  options: FileUploaderOptions = {
    url: ''
  }
  isUploading = false;
  queue: FileItem[] = [];
  progress = 0;
  _nextIndex = 0;
  response: EventEmitter<any>;

  constructor(options: FileUploaderOptions) {
    this.setOptions(options);
  }

  uploadItem(value: FileItem) {
    const index = this.getIndexOfItem(value);
    const item = this.queue[index];
    item._prepareToUploading();
    if (this.isUploading) {
      return;
    }
    this.isUploading = true;
    this._xhrTransport(item);
  }

  getIndexOfItem(value: any): number {
    return typeof value === 'number' ? value : this.queue.indexOf(value);
  }

  setOptions(options) {
    this.options = Object.assign(this.options, options);
  }

  protected _xhrTransport(item: FileItem) {
    const that = this;
    this.queue = this.queue.filter(i => i !== item);
    const xhr = item._xhr = new XMLHttpRequest();
    let sendable: any;
    if (typeof item._file.size !== 'number') {
      throw new TypeError('File not valid');
    }
    sendable = new FormData();
    const appendFile = () => sendable.append(item.alias, item._file, item.file.name);
    appendFile();
    xhr.upload.onprogress = (event: any) => {
      const progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
    }

    xhr.onload = () => {
      const headers = this._parseHeaders(xhr.getAllResponseHeaders());
      const response = xhr.response;
      that._onCompleteItem(item, response, xhr.status, headers);
    }
    xhr.open(item.method, item.url, true);
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    xhr.setRequestHeader('Authorization', `Bearer ${currentUser.token}`);
    this.options.headers.forEach(h => xhr.setRequestHeader(h.name, h.value));
    xhr.send(sendable);
  }

  protected _parseHeaders(headers: string): ParsedResponseHeaders {
    const parsed: any = {};
    let key: any;
    let val: any;
    let i: any;
    if (!headers) {
      return parsed;
    }
    headers.split('\n').map(line => {
      i = line.indexOf(':');
      key = line.slice(0, i).trim().toLowerCase();
      val = line.slice(i + 1).trim();
      if (key) {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    });
    return parsed;
  }

  _onCompleteItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) {
    this.onCompleteItem(item, response, status, headers);
    const nextItem = this.getReadyItems()[0];
    this.isUploading = false;
    if (nextItem) {
      this._xhrTransport(nextItem);
      return;
    }
    this.onCompleteAll();
  }

  getReadyItems() {
    return this.queue.filter(i => !i.isUploading).sort((i, ii) => i.index - ii.index)
  }

  onCompleteItem(item: any, response: any, status: number, headers: any): any {
    return {item, response, status, headers}
  }

  onCompleteAll() {
  }

  onAfterAddingFile(fileItem: FileItem): any {
    return {fileItem};
  }

  addToQueue(files: File[]) {
    Array.from(files).map(f => {
      this.queue.push(new FileItem(this, f));
    });
    this.uploadItem(this.queue[0]);
  }
}
